import vm from '@/main.js'
import * as HelperModel from '@/models/manager.js'

class ManagerHelpers {

    validatorModel() {
        return JSON.parse(JSON.stringify(HelperModel.validator))
    }

    newItemModel() {
        return JSON.parse(JSON.stringify(HelperModel.newItem))
    }

    validateForm(name, email, password, password_confirm, np, rnp) {
        var validator = this.validatorModel()
        if (name === null || name.length <= 0) {
            validator.username.error_show = true;
            validator.username.error_msg = vm.$vuetify.lang.t(
                "$vuetify.errors.required"
            );
            validator.hasError = true;
        } else {
            validator.username.error_show = false;
            validator.username.error_msg = null;
            validator.hasError = false;
        }

        if (password === null || password.length <= 0) {
            validator.password.error_show = true;
            validator.password.error_msg = vm.$vuetify.lang.t(
                "$vuetify.errors.required"
            );
            validator.hasError = true;
        } else {
            validator.password.error_show = false;
            validator.password.error_msg = null;
            validator.hasError = validator.hasError ? true : false;
        }

        if (password_confirm === null || password !== password_confirm) {
            validator.password_confirm.error_show = true;
            validator.password_confirm.error_msg = vm.$vuetify.lang.t(
                "$vuetify.errors.dont_match"
            );
            validator.hasError = true;
        } else {
            validator.password_confirm.error_show = false;
            validator.password_confirm.error_msg = null;
            validator.hasError = validator.hasError ? true : false;
        }

        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (email === null || email.length <= 0 || !re.test(email)) {
            validator.email.error_show = true;
            validator.email.error_msg = vm.$vuetify.lang.t(
                "$vuetify.errors.required"
            );
            validator.hasError = true;
        } else {
            validator.email.error_show = false;
            validator.email.error_msg = null;
            validator.hasError = validator.hasError ? true : false;
        }

        if(np!=null && np!=rnp) {
            validator.new_pass.error_show = true;
            validator.new_pass.error_msg = vm.$vuetify.lang.t(
                "$vuetify.errors.dont_match"
            );
            validator.hasError = true;
        }

        return validator;
    }

}

const ManagerHelper = new ManagerHelpers
export default ManagerHelper